import React, { useEffect, useState } from "react";
import { API_usuarios, API_ciudadanos, API_BASE_URL, BASE_URL } from "../../config/apiConfig";
import { FaLocationDot, FaPhone, FaEnvelope, FaPenToSquare, FaCheck, FaX } from "react-icons/fa6";
import { toast } from "react-toastify";
import "../../pages/user/css/Curriculum.css";
import { useAuth } from "../../context/AuthContext";

const Datos = ({ rol, usuario, setUsuario }) => {
  console.log("Datos.js - usuario:", usuario);
  const { token } = useAuth();

  const [foto, setFoto] = useState("");
  const fotoPerfilDefault =
    "https://static.vecteezy.com/system/resources/previews/036/280/651/non_2x/default-avatar-profile-icon-social-media-user-image-gray-avatar-icon-blank-profile-silhouette-illustration-vector.jpg";
  const [nombre, setNombre] = useState("");
  const [apellido1, setApellido1] = useState("");
  const [apellido2, setApellido2] = useState("");
  const [nacimiento, setNacimiento] = useState("");
  const [dni, setDni] = useState("");
  const [genero, setGenero] = useState("");
  const [nacionalidad, setNacionalidad] = useState("");
  const [direccion, setDireccion] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [pais, setPais] = useState("");
  const [telefono, setTelefono] = useState("");
  const [correo, setCorreo] = useState("");
  const [tipoDiscapacidad, setTipoDiscapacidad] = useState("");
  const [porcentajeDiscapacidad, setPorcentajeDiscapacidad] = useState("");
  const [sngj, setSngj] = useState("");

  // Almacenar valores temporales
  const [tempFoto, setTempFoto] = useState("");
  const [tempNombre, setTempNombre] = useState("");
  const [tempApellido1, setTempApellido1] = useState("");
  const [tempApellido2, setTempApellido2] = useState("");
  const [tempNacimiento, setTempNacimiento] = useState("");
  const [tempDni, setTempDni] = useState("");
  const [tempGenero, setTempGenero] = useState("");
  const [tempNacionalidad, setTempNacionalidad] = useState("");
  const [tempDireccion, setTempDireccion] = useState("");
  const [tempCiudad, setTempCiudad] = useState("");
  const [tempCodigoPostal, setTempCodigoPostal] = useState("");
  const [tempPais, setTempPais] = useState("");
  const [tempTelefono, setTempTelefono] = useState("");
  const [tempCorreo, setTempCorreo] = useState("");
  const [tempSngj, setTempSngj] = useState("");
  const [tempTipoDiscapacidad, setTempTipoDiscapacidad] = useState("");
  const [tempPorcentajeDiscapacidad, setTempPorcentajeDiscapacidad] = useState("");

  // Estados de edición
  const [editando, setEditando] = useState({
    foto: false,
    nombre: false,
    apellido1: false,
    apellido2: false,
    nacimiento: false,
    dni: false,
    genero: false,
    nacionalidad: false,
    direccion: false,
    ciudad: false,
    codigoPostal: false,
    pais: false,
    telefono: false,
    correo: false,
    sngj: false,
    discapacidad: false,
  });

  // Estado para la imagen cargada con autenticación
  const [imagenSrc, setImagenSrc] = useState("");

  // Constantes de texto por defecto si no hay datos
  const TEXTO_POR_DEFECTO = {
    nacimiento: "Cumpleaños !",
    genero: "Género !",
    nacionalidad: "Nacionalidad !",
    discapacidad: "¿Sí o no?",
    sngj: "¿Sí o no?",
  };

  // useEffect(() => {
  //   const obtenerEmailYCompletarUsuario = async () => {
  //     try {
  //       // Paso 1: Obtener usuarios con email
  //       const res = await fetch(API_usuarios, {
  //         headers: {
  //           "x-auth-token": token,
  //         },
  //       });
  //       const usuarios = await res.json();

  //       // Paso 2: Buscar el usuario logueado por name (o como lo identifiques)
  //       const usuarioConEmail = usuarios.find(
  //         (u) => u.name?.toLowerCase() === usuario.name?.toLowerCase()
  //       );

  //       // Paso 3: Si encontramos el usuario, añadimos el email a los datos del usuario
  //       if (usuarioConEmail) {
  //         usuario.email = usuarioConEmail.email;
  //         setCorreo(usuarioConEmail.email);
  //         setTempCorreo(usuarioConEmail.email);
  //       }
  //     } catch (error) {
  //       console.error("Error al obtener email desde API_usuarios:", error);
  //     }
  //   };

  //   if (usuario) {
  //     obtenerEmailYCompletarUsuario();
  //   }
  // }, [usuario]);

  // useEffect para cargar imagen con autenticación
  useEffect(() => {
    const cargarImagen = async () => {
      // Si no hay foto del usuario o no hay tempFoto, usar imagen por defecto
      if (!tempFoto) {
        setImagenSrc(fotoPerfilDefault);
        return;
      }

      try {
        // Si hay token, hacer petición autenticada
        if (token) {
          const response = await fetch(tempFoto, {
            headers: {
              "x-auth-token": token,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const imageObjectURL = URL.createObjectURL(blob);
            setImagenSrc(imageObjectURL);
          } else {
            // Si falla la carga, usar imagen por defecto
            setImagenSrc(fotoPerfilDefault);
          }
        } else {
          // Si no hay token, intentar cargar directamente (por si es una URL pública)
          setImagenSrc(tempFoto);
        }
      } catch (error) {
        console.error("Error al cargar imagen:", error);
        setImagenSrc(fotoPerfilDefault);
      }
    };

    cargarImagen();

    // Cleanup: revocar URL del objeto cuando el componente se desmonte
    return () => {
      if (imagenSrc && imagenSrc.startsWith("blob:")) {
        URL.revokeObjectURL(imagenSrc);
      }
    };
  }, [tempFoto, token]);

  // Cargar los datos reales del usuario
  useEffect(() => {
    if (usuario) {
      const imagen = usuario?.profileImageUrl ? `${BASE_URL}${usuario.profileImageUrl}` : "";
      const nombre = usuario.name || "";
      const apellidos = usuario.lastName?.split(" ") || [];
      const apellido1 = apellidos[0] || "";
      const apellido2 = apellidos[1] || "";

      setFoto(imagen);
      setTempFoto(imagen); // Asegura que tempFoto tenga valor inicial

      setNombre(nombre);
      setTempNombre(nombre);

      setApellido1(apellido1);
      setApellido2(apellido2);
      setTempApellido1(apellido1);
      setTempApellido2(apellido2);

      setNacimiento(usuario.birthdate?.split("T")[0] || "");
      setTempNacimiento(usuario.birthdate?.split("T")[0] || "");

      setDni(usuario.dni || "");
      setTempDni(usuario.dni || "");

      setGenero(usuario.gender || "");
      setTempGenero(usuario.gender || "");

      setNacionalidad(usuario.nationality || "");
      setTempNacionalidad(usuario.nationality || "");

      setDireccion(usuario.address || "");
      setTempDireccion(usuario.address || "");

      setCiudad(usuario.city || "");
      setTempCiudad(usuario.city || "");

      setCodigoPostal(usuario.postalCode?.toString() || "");
      setTempCodigoPostal(usuario.postalCode?.toString() || "");

      setPais(usuario.country || "");
      setTempPais(usuario.country || "");

      setTelefono(usuario.phone || "");
      setTempTelefono(usuario.phone || "");

      const email = usuario.email || "";
      setCorreo(email);
      setTempCorreo(email);

      const sngjValor = usuario.esSngj === true ? "Sí" : usuario.esSngj === false ? "No" : "";

      setSngj(sngjValor);
      setTempSngj(sngjValor);

      const tipoDiscapacidad = usuario.discapacidad?.tipo || "";
      const porcentajeDiscapacidad = usuario.discapacidad?.porcentaje?.toString() || "";

      setTipoDiscapacidad(tipoDiscapacidad);

      setTipoDiscapacidad(tipoDiscapacidad);
      setTempTipoDiscapacidad(tipoDiscapacidad);

      setPorcentajeDiscapacidad(porcentajeDiscapacidad);
      setTempPorcentajeDiscapacidad(porcentajeDiscapacidad);
    }
  }, [usuario]);

  // Guardar cambios
  const handleSaveDatos = async () => {
    const body = {
      name: tempNombre || null,
      lastName: tempApellido2 ? `${tempApellido1} ${tempApellido2}` : tempApellido1 || null,
      birthdate: tempNacimiento ? new Date(tempNacimiento).toISOString() : null,
      nationality: tempNacionalidad || null,
      email: tempCorreo || null,
      gender: tempGenero || null,
      dni: tempDni || null,
      phone: tempTelefono || null,
      address: tempDireccion || null,
      postalCode: tempCodigoPostal ? parseInt(tempCodigoPostal) : null,
      city: tempCiudad || null,
      country: tempPais || null,
      discapacidad: {
        tipo: tempTipoDiscapacidad || null,
        grado: null,
        porcentaje:
          tempTipoDiscapacidad.toLowerCase() === "no tiene"
            ? null
            : tempPorcentajeDiscapacidad
            ? parseInt(tempPorcentajeDiscapacidad)
            : null,
      },
      esSngj: tempSngj === "Sí",
    };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": token,
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Error al actualizar los datos del usuario");

      // ✅ Actualizar estados reales con los temporales
      setNombre(tempNombre);
      setApellido1(tempApellido1);
      setApellido2(tempApellido2);
      setNacimiento(tempNacimiento);
      setNacionalidad(tempNacionalidad);
      setGenero(tempGenero);
      setDni(tempDni);
      // setFoto(tempFoto);
      setTelefono(tempTelefono);
      setDireccion(tempDireccion);
      setCodigoPostal(tempCodigoPostal);
      setCiudad(tempCiudad);
      setPais(tempPais);
      setTipoDiscapacidad(tempTipoDiscapacidad);
      setPorcentajeDiscapacidad(tempPorcentajeDiscapacidad);
      setSngj(tempSngj);
      setCorreo(tempCorreo);

      // ✅ Actualizar el estado del usuario en el componente padre
      if (setUsuario) {
        setUsuario((prevUsuario) => ({
          ...prevUsuario,
          name: tempNombre,
          lastName: tempApellido2 ? `${tempApellido1} ${tempApellido2}` : tempApellido1,
          email: tempCorreo || prevUsuario.email,
          birthdate: tempNacimiento ? new Date(tempNacimiento).toISOString() : prevUsuario.birthdate,
          nationality: tempNacionalidad || prevUsuario.nationality,
          gender: tempGenero || prevUsuario.gender,
          dni: tempDni || prevUsuario.dni,
          // profileImageUrl: tempFoto || prevUsuario.profileImageUrl,
          phone: tempTelefono || prevUsuario.phone,
          address: tempDireccion || prevUsuario.address,
          postalCode: tempCodigoPostal ? parseInt(tempCodigoPostal) : prevUsuario.postalCode,
          city: tempCiudad || prevUsuario.city,
          country: tempPais || prevUsuario.country,
          discapacidad: {
            tipo: tempTipoDiscapacidad || null,
            grado: null,
            porcentaje:
              tempTipoDiscapacidad.toLowerCase() === "no tiene"
                ? null
                : tempPorcentajeDiscapacidad
                ? parseInt(tempPorcentajeDiscapacidad)
                : null,
          },
          esSngj: tempSngj === "Sí",
        }));
      }

      toast.success("Dato actualizado correctamente");

      // ✅ Salir del modo edición
      setEditando({});
    } catch (error) {
      console.error("❌ Error al actualizar datos:", error);
      toast.error("Error al guardar los datos");
    }
  };

  // Cancelar edición
  const handleCancel = (campo) => {
    switch (campo) {
      case "foto":
        setTempFoto(foto);
        break;
      case "nombre":
        setTempNombre(nombre);
        setTempApellido1(apellido1);
        setTempApellido2(apellido2);
        break;
      case "nacimiento":
        setNacimiento(tempNacimiento);
        break;
      case "dni":
        setDni(tempDni);
        break;
      case "genero":
        setGenero(tempGenero);
        break;
      case "nacionalidad":
        setNacionalidad(tempNacionalidad);
        break;
      case "direccion":
        setDireccion(tempDireccion);
        setCiudad(tempCiudad);
        setCodigoPostal(tempCodigoPostal);
        setPais(tempPais);
        break;
      case "telefono":
        setTempTelefono(telefono);
        break;
      case "correo":
        setTempCorreo(correo);
        break;
      case "sngj":
        setTempSngj(sngj);
        break;
      case "discapacidad":
        setTempTipoDiscapacidad(tipoDiscapacidad);
        setTempPorcentajeDiscapacidad(porcentajeDiscapacidad);
        break;
      default:
        break;
    }
    setEditando({ ...editando, [campo]: false });
  };

  // Manejar cambio de foto de perfil
  const handleFotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("folder", "fotos"); // Default folder name
        formData.append("userId", usuario.userId); // Default folder name

        // Upload the file
        const response = await fetch(`${API_ciudadanos}/${usuario.userId}/files`, {
          method: "POST",
          headers: {
            "x-auth-token": token,
          },
          body: formData,
        });

        // "/api/downloads/ciudadanos/689b22230b7d7c31081ace70"

        if (!response.ok) {
          throw new Error("Error al subir la foto");
        }
        const data = await response.json();
        if (!data.isOk) {
          throw new Error("Error al subir la foto");
        }

        const res = await fetch(`${API_ciudadanos}/${usuario.userId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": token,
          },
          body: JSON.stringify({
            profileImageUrl: `/api/downloads/ciudadanos/${data.fileIds.at(-1)}`,
          }),
        });

        if (!res.ok) throw new Error("Error al actualizar los datos del usuario");

        setFoto(`${API_BASE_URL}/downloads/ciudadanos/${data.fileIds.at(-1)}`);
        setTempFoto(`${API_BASE_URL}/downloads/ciudadanos/${data.fileIds.at(-1)}`);
        toast.success("Foto de perfil actualizada correctamente");
      } catch (error) {
        console.error("Error al subir la foto:", error);
        toast.error("Error al subir la foto");
        return;
      }

      // const reader = new FileReader();
      // reader.onloadend = () => {
      //   setFoto(reader.result);
      //   setTempFoto(reader.result);
      // };
      // reader.readAsDataURL(file);
    }
  };

  const formatearFecha = (fechaISO) => {
    if (!fechaISO) return "";
    const fecha = new Date(fechaISO);
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();
    return `${dia}/${mes}/${año}`;
  };

  return (
    <div className="personal column">
      {/*  Foto, nombre y apellidos */}
      <div className="foto-nombre flex">
        {/*  Foto */}
        <label className="foto-perfil-label">
          <img
            src={imagenSrc || fotoPerfilDefault}
            alt={`${tempNombre} ${tempApellido1}`}
            className="foto-perfil cursor"
            onError={() => setImagenSrc(fotoPerfilDefault)}
          />
          <input type="file" accept="image/*" className="hidden-input" onChange={handleFotoChange} />
        </label>

        {/*  Nombre y apellidos */}
        <div className="nombre-apellidos flex gap-[0.5rem]">
          {!editando.nombre && (
            <FaPenToSquare onClick={() => setEditando({ ...editando, nombre: true })} className="hover-verde edit-nombre-icon" />
          )}
          {editando.nombre ? (
            <div className="column gap-10">
              <input
                aria-label="Nombre"
                type="text"
                value={tempNombre}
                onChange={(e) => setTempNombre(e.target.value)}
                className="input-nombre"
                placeholder="Nombre"
              />
              <input
                aria-label="Primer apellido"
                type="text"
                value={tempApellido1}
                onChange={(e) => setTempApellido1(e.target.value)}
                className="input-apellido"
                placeholder="Primer apellido"
              />
              <input
                aria-label="Segundo apellido"
                type="text"
                value={tempApellido2}
                onChange={(e) => setTempApellido2(e.target.value)}
                className="input-apellido"
                placeholder="Segundo apellido"
              />
              <div className="check flex gap-5 mt-10">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("nombre")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("nombre")}>
                  <FaX />
                </button>
              </div>
            </div>
          ) : (
            <h1 className="bold leading-[1.2]">
              {nombre} {apellido1} {apellido2}
            </h1>
          )}
        </div>
      </div>

      <div className="datos-genericos between">
        {/*  Dni */}
        {rol === "administrador" ? (
          <div className="align-center gap-5">
            {!editando.dni && <FaPenToSquare onClick={() => setEditando({ ...editando, dni: true })} />}
            {editando.dni ? (
              <>
                <input type="text" className="w-80" value={tempDni} onChange={(e) => setTempDni(e.target.value)} />
                <div className="check flex gap-5 mt-5">
                  <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("dni")}>
                    <FaCheck />
                  </button>
                  <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("dni")}>
                    <FaX />
                  </button>
                </div>
              </>
            ) : (
              <>
                <p>{dni}</p>
              </>
            )}
          </div>
        ) : (
          <p className="align-center gap-5">
            <span>{dni}</span>
          </p>
        )}

        {/*  Fecha nacimiento */}
        <p className="align-center end gap-5">
          {editando.nacimiento ? (
            <>
              <input
                aria-label="Fecha de nacimiento"
                type="date"
                value={tempNacimiento}
                onChange={(e) => setTempNacimiento(e.target.value)}
              />
              <div className="check flex gap-5 mt-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("nacimiento")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("nacimiento")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <>
              <span className={!nacimiento ? "texto-defecto" : ""}>
                {nacimiento ? formatearFecha(nacimiento) : TEXTO_POR_DEFECTO.nacimiento}
              </span>
              <FaPenToSquare onClick={() => setEditando({ ...editando, nacimiento: true })} />
            </>
          )}
        </p>

        {/*  Genero */}
        <p className="align-center gap-5">
          {!editando.genero && <FaPenToSquare onClick={() => setEditando({ ...editando, genero: true })} />}
          {editando.genero ? (
            <>
              <select className="w-80" value={tempGenero} onChange={(e) => setTempGenero(e.target.value)} aria-label="Genero">
                <option value="Mujer">Mujer</option>
                <option value="Hombre">Hombre</option>
                <option value="Sin especificar">-</option>
              </select>
              <div className="check flex gap-5 mt-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("genero")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("genero")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <>
              <span className={!genero ? "texto-defecto" : ""}>{genero || TEXTO_POR_DEFECTO.genero}</span>
            </>
          )}
        </p>

        {/*  Nacionalidad */}
        <p className="align-center end gap-5">
          {editando.nacionalidad ? (
            <>
              <select value={tempNacionalidad} onChange={(e) => setTempNacionalidad(e.target.value)} aria-label="Nacionalidad">
                <option value="España">España</option>
                <option value="México">México</option>
                <option value="Argentina">Argentina</option>
                <option value="Colombia">Colombia</option>
                <option value="Otro">Otro</option>
              </select>
              <div className="check flex gap-5 mt-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("nacionalidad")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("nacionalidad")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <>
              <span className={!nacionalidad ? "texto-defecto" : ""}>{nacionalidad || TEXTO_POR_DEFECTO.nacionalidad}</span>
              <FaPenToSquare onClick={() => setEditando({ ...editando, nacionalidad: true })} />
            </>
          )}
        </p>
      </div>

      <div className="contacto column gap-5">
        {/*  Dirección */}
        <p className="align-center gap-10 w-100">
          {!editando.direccion && <FaPenToSquare onClick={() => setEditando({ ...editando, direccion: true })} className="hover-verde" />}
          <FaLocationDot className="verde" />
          {editando.direccion ? (
            <>
              <div className="column gap-10 w-300">
                <div className="wrap gap-5">
                  <input
                    aria-label="Dirección"
                    type="text"
                    value={tempDireccion}
                    onChange={(e) => setTempDireccion(e.target.value)}
                    className="w-250"
                  />
                  <input
                    aria-label="Municipio"
                    type="text"
                    value={tempCiudad}
                    onChange={(e) => setTempCiudad(e.target.value)}
                    className="w-250"
                  />
                  <div className="wrap gap-10">
                    <select
                      value={tempCodigoPostal}
                      onChange={(e) => setTempCodigoPostal(e.target.value)}
                      className="w-75"
                      aria-label="Código postal"
                    >
                      <option value="21410">21410</option>
                      <option value="21420">21420</option>
                      <option value="21430 ">21430 </option>
                      <option value="21449">21449</option>
                    </select>
                    <input aria-label="País" type="text" value={tempPais} onChange={(e) => setTempPais(e.target.value)} className="w-120" />
                  </div>
                </div>
                <div className="check flex gap-5">
                  <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("direccion")}>
                    <FaCheck />
                  </button>
                  <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("direccion")}>
                    <FaX />
                  </button>
                </div>
              </div>
            </>
          ) : (
            <span className="direccion">
              {direccion}, {ciudad}, {codigoPostal}, {pais}
            </span>
          )}
        </p>

        {/*  Teléfono */}
        <p className="align-center gap-10">
          {!editando.telefono && <FaPenToSquare onClick={() => setEditando({ ...editando, telefono: true })} className="hover-verde" />}
          <FaPhone className="verde" />
          {editando.telefono ? (
            <>
              <input
                aria-label="Teléfono"
                type="text"
                value={tempTelefono}
                onChange={(e) => setTempTelefono(e.target.value)}
                className="w-250"
              />
              <div className="check flex gap-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("telefono")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("telefono")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <span>{telefono}</span>
          )}
        </p>

        {/*  Email */}
        {/* <p className="align-center gap-10">
          <FaEnvelope className="verde" />
          <span>{correo}</span>
        </p> */}

        <p className="align-center gap-10">
          {!editando.correo && <FaPenToSquare onClick={() => setEditando({ ...editando, correo: true })} className="hover-verde" />}
          <FaEnvelope className="verde" />
          {editando.correo ? (
            <>
              <input
                aria-label="Correo electrónico"
                type="email"
                value={tempCorreo}
                onChange={(e) => setTempCorreo(e.target.value)}
                className="w-250"
              />
              <div className="check flex gap-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("correo")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("correo")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <span>{correo}</span>
          )}
        </p>
      </div>

      {/*  Nivel de educación más alto */}
      {/* {rol !== "ciudadano" && (
          <div className="mayor-educacion">
              <p className="verde bold">Nivel de educacion más alto:</p>
              <p>Educación secundaria alta</p>
          </div>
      )} */}

      <div className="otros-datos">
        {/*  Discapacidad */}
        <p className="align-center gap-10">
          {!editando.discapacidad && (
            <FaPenToSquare onClick={() => setEditando({ ...editando, discapacidad: true })} className="hover-verde" />
          )}
          <span className="verde bold">Discapacidad:</span>
          {editando.discapacidad ? (
            <>
              <select
                value={tempTipoDiscapacidad}
                onChange={(e) => setTempTipoDiscapacidad(e.target.value)}
                aria-label="Tipo de discapacidad"
              >
                <option value="Fisica">Física</option>
                <option value="Sensorial">Sensorial</option>
                <option value="Psiquica">Psíquica</option>
                <option value="Intelectual">Intelectual</option>
                <option value="no tiene">No tiene</option>
              </select>
              {tempTipoDiscapacidad !== "no tiene" && (
                <>
                  <input
                    aria-label="Porcentaje de discapacidad"
                    className="w-25"
                    type="text"
                    value={tempPorcentajeDiscapacidad}
                    onChange={(e) => setTempPorcentajeDiscapacidad(e.target.value)}
                  />
                  %
                </>
              )}
              <div className="check flex gap-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("discapacidad")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("discapacidad")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <>
              <span className={!tipoDiscapacidad ? "texto-defecto" : ""}>
                {tipoDiscapacidad?.toLowerCase() === "no tiene" ? "No tiene" : tipoDiscapacidad || TEXTO_POR_DEFECTO.discapacidad}
                {tipoDiscapacidad &&
                  tipoDiscapacidad.toLowerCase() !== "no tiene" &&
                  porcentajeDiscapacidad &&
                  ` ${porcentajeDiscapacidad}%`}
              </span>
            </>
          )}
        </p>

        {/*  SNGJ */}
        <p className="align-center gap-10">
          {!editando.sngj && <FaPenToSquare onClick={() => setEditando({ ...editando, sngj: true })} className="hover-verde" />}
          <span className="verde bold">SNGJ:</span>
          {editando.sngj ? (
            <>
              <select value={tempSngj} onChange={(e) => setTempSngj(e.target.value)} aria-label="Sistema Nacional de Garantía Juvenil">
                <option value="Sí">Sí</option>
                <option value="No">No</option>
              </select>

              <div className="check flex gap-5">
                <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveDatos("sngj")}>
                  <FaCheck />
                </button>
                <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={() => handleCancel("sngj")}>
                  <FaX />
                </button>
              </div>
            </>
          ) : (
            <>
              <span className={!sngj ? "texto-defecto" : ""}>{sngj || TEXTO_POR_DEFECTO.sngj}</span>
            </>
          )}
        </p>
      </div>

      {/*  Fechas de alta - solo la pueden ver los técnicos */}
      {rol !== "ciudadano" && usuario.updatedAt && (
        <div className="alta-baja">
          <p>
            <span className="verde bold">Fecha alta:</span> {formatearFecha(usuario.createdAt)}
          </p>
        </div>
      )}
      <div>
        <p className="text-sm italic">
          Aceptó los Términos y Condiciones de uso correspondientes a la versión vigente en la fecha {formatearFecha(usuario.createdAt)}.
        </p>
      </div>
    </div>
  );
};

export default Datos;
